import { Loader2 } from "lucide-react";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { useCompleteNewPassword } from "~/api/authentication/authentication";
import { useGetPasswordRules } from "~/api/users/users";
import SmartPasswordInput from "~/components/smart-password-input";
import { storeAccessToken, storeRefreshToken, storeUsername } from "~/helpers";

export const ChangePasswordForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { session, username } = location.state || {};

  const {
    mutate: completeNewPassword,
    isPending,
    isError,
  } = useCompleteNewPassword();

  const { data: passwordRules, isLoading: isLoadingPasswordRules } =
    useGetPasswordRules();

  const onSavePasswordClick = (password: string) => {
    completeNewPassword(
      { data: { newPassword: password, session, username } },
      {
        onSuccess: (data) => {
          if (data.AccessToken && data.RefreshToken) {
            storeAccessToken(data.AccessToken);
            storeRefreshToken(data.RefreshToken);
            storeUsername(username);
            navigate("/");
          }
        },
      }
    );
  };

  return (
    <div className="flex justify-center items-start pt-10">
      {isLoadingPasswordRules ? (
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        </div>
      ) : (
        <div className="flex flex-col gap-6 max-w-lg w-full">
          <div className="flex flex-col gap-4 items-center">
            <h3 className="text-2xl font-semibold text-center text-base-foreground">
              <FormattedMessage
                id="changePasswordForm.title"
                defaultMessage="Complete Registration"
              />
            </h3>
            <span className="text-sm text-muted-foreground">
              <FormattedMessage
                id="changePasswordForm.subtitle"
                defaultMessage="To complete your registration, please come up with a password."
              />
            </span>
          </div>
          <SmartPasswordInput
            onPasswordSubmit={onSavePasswordClick}
            activeRequirements={passwordRules?.rules || []}
            isPending={isPending}
          />
          {isError && (
            <p className="mt-4 text-red-600 text-sm text-center">
              <FormattedMessage
                id="changePasswordForm.error"
                defaultMessage="Failed to change password"
              />
            </p>
          )}
        </div>
      )}
    </div>
  );
};
